import React, { useCallback } from 'react'

import { Box, Typography } from '@material-ui/core'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import ChipSelector from 'components/ChipSelector'
import { withContext } from '../Context'

export const SegmentName = 'NeighborhoodType'
const OPTIONS = [
  {
    value: 'city',
    label: 'City',
  },
  {
    value: 'suburban',
    label: 'Suburban',
  },
  {
    value: 'town',
    label: 'Town',
  },
  {
    value: 'rural',
    label: 'Rural',
  },
]

const getCurrentSelection = (segment: object, criteria: string) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  return OPTIONS.filter((option) => {
    return currentValue.includes(option.value)
  })
}

type CommunityTypeSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation?: string) => void
  segment: object
}

export const CommunityTypeSelector = ({ criteria = 'Must', segment, onChange }: CommunityTypeSelectorProps) => {
  const [selected, setSelected] = React.useState(getCurrentSelection(segment, criteria))
  const change = useCallback(
    (values) => {
      onChange(criteria, SegmentName, values)
    },
    [criteria, onChange],
  )
  return (
    <>
      <Box py={2}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Community Type
        </Typography>
      </Box>
      <Box pb={2}>
        <ChipSelector
          options={OPTIONS}
          selected={selected}
          onUpdateSelection={(values) => {
            setSelected(values)
            change(values.map((value: { value: string }) => value.value))
          }}
        />
      </Box>
    </>
  )
}

export default withContext(CommunityTypeSelector)
